import {
    Col,
    message,
    Row,
    Anchor,
    Form,
    Input,
    InputNumber,
    Upload,
    Select, Button, AutoComplete
} from "antd";
import React, {useEffect, useRef, useState} from "react";
import { updateDataContent, locationSearch } from "../../utils/formUtils";
import { LoadingScreen } from "../ui/LoadingScreen";
import { SaveIcon } from "../ui/SaveIcon";
import { MyInputNumber } from "../ui/MyInputNumber";
import { useModals } from "../../hooks/useModals";
import { useGutachtenPersist } from "../../hooks/useGutachtenPersist";
import { useGutachtenData } from "../../hooks/useGutachtenData";
import { useParams } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import { FileTextOutlined } from "@ant-design/icons";
import { useSwitch } from '../../pages/SwitchContext';
import {RiDeleteBin5Fill} from "react-icons/ri";
import GutachtenShell from "./GutachtenShell";
const { Dragger } = Upload;
const { Option } = Select;

const MENU_LINKS = [
    { href: '#kurzbeschreibung', title: 'Kurzbeschreibung' },
    { href: '#beschaffenheit', title: 'Beschaffenheit' },
    { href: '#strasse-anschluesse', title: 'Straße & Anschlüsse' },
    { href: '#grenzverhaeltnisse-baugrund', title: 'Grenzverhältnisse & Baugrund' },
    { href: '#grundbuch', title: 'Grundbuch' },
    { href: '#planung', title: 'Planung' },
    { href: '#rechte-belastungen', title: 'Rechte & Belastungen' },
    { href: '#naturgefahren', title: 'Naturgefahren' },
    { href: '#beurteilung-grundstueck', title: 'Beurteilung Grundstück' },
];




const FormContainer = () => {
    const [formFormular1] = Form.useForm();
    const inputRefs = useRef({});

    const handleRef = (name, element) => {
        if (element) inputRefs.current[name] = element;
    };
    const { auftragID, gutachtenID, tab } = useParams();
    const [selectedOption, setSelectedOption] = useState(null);
    const { isSwitchOn } = useSwitch();
    const { saveIcon, saveIcon1, isLoading, setIsLoading, updateGutachten } = useGutachtenPersist(gutachtenID);
    const { modals, handleOpenTextbausteine, handleCloseTextbausteine, renderModals, selectedTextBausteine } = useModals();

    const handleSelectChange = (value) => setSelectedOption(value);

    const { dataContentRef, initialValues, enumerationValues } = useGutachtenData(gutachtenID, {
        setIsLoading,
        updateTrigger: false,
        saveIcon,
    });

    const triggerFocus = (name) => {
        if (inputRefs.current[name]) inputRefs.current[name].focus();
    };
    useEffect(() => {
        if (selectedTextBausteine) {
            formFormular1.setFieldsValue({ [modals[modals.length - 1].field]: selectedTextBausteine });
            triggerFocus(modals[modals.length - 1].field);
        }
    }, [selectedTextBausteine]);

    useEffect(() => formFormular1.resetFields(), [initialValues]);

    return (
        <div className={`${isSwitchOn ? 'bg-black' : 'bg-white'} sm:p-[20px] p-[10px] rounded-[30px]`}>
            {isLoading && <LoadingScreen />}
            {saveIcon1 && <SaveIcon saveIcon={saveIcon} />}
            {renderModals()}
            <h2 className={`${isSwitchOn ? 'text-white' : 'text-black'} font-bold text-16px  md:text-[28px] mb-[20px] generalText`}>Grundstück</h2>
            <div>
                {dataContentRef.current && enumerationValues && (
                    <Form
                        form={formFormular1}
                        onBlur={(e) => {
                            if (e.target.type === "button") return;
                            const updateValue = e.target.type === "search"
                                ? (setSelectedOption(null), selectedOption)
                                : e.target.value;
                            const updateByIDArray = [];
                            if (updateByIDArray.some(value => e.target.id.includes(value))) {
                                updateDataContent(e.target.id, updateValue, dataContentRef.current, "updateByID");
                            } else {
                                updateDataContent(e.target.id, updateValue, dataContentRef.current, "updateByIndex");
                            }
                            updateGutachten(dataContentRef.current);
                        }}
                        initialValues={initialValues}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        layout="horizontal"
                    // style={{ maxWidth: 800 }}
                    >
                        <div id="Kurzbeschreibung" className="scrollable-section">
                            <h3 className={`font-bold text-16px mb-[12px]  md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Kurzbeschreibung</h3>
                            <div className={`allgemeineClass ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Kurzbeschreibung" name="Grundstueck__GS_Kurzbeschreibung">
                                    <TextArea  autoSize={true} className="textInput"  ref={(element) => handleRef('Grundstueck__GS_Kurzbeschreibung', element)} />
                                </Form.Item>
                            </div>
                        </div>
                        <div id="beschaffenheit" className="scrollable-section">
                            <h3 className={`font-bold text-16px mb-[12px]  md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Beschaffenheit</h3>
                            <div className={`allgemeineClass ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Straßenfront" name="Grundstueck__GS_Strassenfront">
                                    <Input className="inputsAll" />
                                </Form.Item>
                                <Form.Item label="Grundstückstiefe" name="Grundstueck__GS_Grundstueckstiefe">
                                    <Input className="inputsAll" />
                                </Form.Item>

                                <Form.Item label="Größe (in m²)" name="Grundstueck__GS_Groesse">
                                    <MyInputNumber className="inputsAll" />
                                </Form.Item>
                                <Form.Item label="Zuschnitt" name="Grundstueck__GS_ZuschnittV">
                                    <AutoComplete
                                        className={"AutoCompleteTextArea"}
                                        options={enumerationValues.sub_com_GS_Zuschnitt?.map(
                                            (option, index) => ({value: option, key: index})
                                        )}
                                        filterOption={(inputValue, option) =>
                                        option.value
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        onChange={handleSelectChange} // Add your change handler if needed
                                    >
                                        <TextArea
                                            placeholder="Zuschnitt"
                                            autoSize={true}
                                            className="textInput"
                                        />
                                    </AutoComplete>

                                </Form.Item>
                                <Form.Item label="Topographie" name="Grundstueck__GS_TopographieV">
                                    <AutoComplete
                                        className={"AutoCompleteTextArea"}
                                        options={enumerationValues?.sub_com_GS_Topographie?.map(
                                            (option, index) => ({ value: option, key: index })
                                        )}
                                        filterOption={(inputValue, option) =>
                                            option.value
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        onChange={handleSelectChange} // Add your change handler if needed
                                    >
                                        <TextArea
                                            placeholder="Topographie"
                                            autoSize={true}
                                            className="textInput"
                                        />
                                    </AutoComplete>

                                </Form.Item>
                            </div>
                        </div>
                        <div id="strasse-anschluesse " className="border-t border-gray-300 pt-[20px] pb-[20px] scrollable-section">
                            <h3 className={`font-bold text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Straße & Anschlüsse</h3>
                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Straßenart" name='Grundstueck__GS_Strassenart'>
                                    <TextArea autoSize={true} className="textInput" ref={(element) => handleRef('Grundstueck__GS_Strassenart', element)} />
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Grundstueck__GS_Strassenart', 'Straßenart', 'Straßenart')} style={{ float: 'right' }} ><FileTextOutlined /></Button>
                            </div>

                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Straßenausbau" name='Grundstueck__GS_Strassenbau'>
                                    <TextArea autoSize={true} className="textInput" ref={(element) => handleRef('Grundstueck__GS_Strassenbau', element)} />
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Grundstueck__GS_Strassenbau', 'Straßenausbau', 'Straßenausbau')} style={{ float: 'right' }} ><FileTextOutlined /></Button>
                            </div>

                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Anschlüsse" name='Grundstueck__GS_Anschluesse'>
                                    <TextArea autoSize={true} className="textInput" ref={(element) => handleRef('Grundstueck__GS_Anschluesse', element)} />
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Grundstueck__GS_Anschluesse', 'Anschlüsse', 'Anschlüsse')} style={{ float: 'right' }} ><FileTextOutlined /></Button>

                            </div>

                        </div>
                        <div id="grenzverhaeltnisse-baugrund" className="scrollable-section border-t border-gray-300 pt-[20px] pb-[20px]">
                            <h3 className={`font-bold text-16px mb-[12px]  md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Grenzverhältnisse & Baugrund</h3>
                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Grenzverhältnisse" name='Grundstueck__GS_Grenzverhaeltnis'>
                                    <TextArea autoSize={true} className="textInput" ref={(element) => handleRef('Grundstueck__GS_Grenzverhaeltnis', element)} />
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Grundstueck__GS_Grenzverhaeltnis', 'Grenzverhältnisse', 'Grenzverhältnisse')} style={{ float: 'right' }} ><FileTextOutlined /></Button>
                            </div>


                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Baugrund & Grundwasser" name='Grundstueck__GS_Baugrund_Grundwasser'>
                                    <TextArea autoSize={true} className="textInput" ref={(element) => handleRef('Grundstueck__GS_Baugrund_Grundwasser', element)} />
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Grundstueck__GS_Baugrund_Grundwasser', 'Baugrund & Grundwasser', 'Baugrund/Grundwasser')} style={{ float: 'right' }} ><FileTextOutlined /></Button>

                            </div>


                        </div>
                        <div id="grundbuch" className="scrollable-section border-t border-gray-300 pt-[20px] pb-[20px]">
                            <h3 className={`font-bold text-16px mb-[12px]  md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Grundbuch</h3>
                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Belastung Grundbuch" name='Grundstueck__RE_Belastung_Grundbuch'>
                                    <TextArea autoSize={true} className="textInput" ref={(element) => handleRef('Grundstueck__RE_Belastung_Grundbuch', element)} />
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Grundstueck__RE_Belastung_Grundbuch', 'Belastung Grundbuch', 'Belastung Grundbuch')} style={{ float: 'right' }} ><FileTextOutlined /></Button>

                            </div>


                        </div>
                        <div id="planung" className="scrollable-section border-t border-gray-300 pt-[20px] pb-[20px]">
                            <h3 className={`font-bold text-16px mb-[12px]  md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Planung</h3>
                            <div className={`allgemeineClass ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Flächennutzungsplan" name='Grundstueck__RE_FlaechennutzungsplanV'>
                                    <AutoComplete
                                        className={"AutoCompleteTextArea"}
                                        options={enumerationValues.sub_com_RE_Flaechennutzungsplan?.map(
                                            (option, index) => ({ value: option, key: index })
                                        )}
                                        filterOption={(inputValue, option) =>
                                            option.value
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        onChange={handleSelectChange} // Add your change handler if needed
                                    >
                                        <TextArea
                                            placeholder="Flächennutzungsplan"
                                            autoSize={true}
                                            className="textInput"
                                        />
                                    </AutoComplete>

                                </Form.Item>
                            </div>

                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Bebauungsplan" name='Grundstueck__RE_Bebauungsplan'>
                                    <TextArea autoSize={true} className="textInput" ref={(element) => handleRef('Grundstueck__RE_Bebauungsplan', element)} />
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Grundstueck__RE_Bebauungsplan', 'Bebauungsplan', 'Bebauungsplan')} style={{ float: 'right' }} ><FileTextOutlined /></Button>

                            </div>


                        </div>
                        <div id="rechte-belastungen" className="scrollable-section border-t border-gray-300 pt-[20px] pb-[20px]">
                            <h3 className={`font-bold text-16px mb-[12px]  md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Rechte & Belastungen</h3>
                            <div className={`allgemeineClass ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Entwicklungszustand" name='Grundstueck__RE_EntwicklungszustandV'>
                                    <AutoComplete
                                        className={"AutoCompleteTextArea"}
                                        options={enumerationValues.sub_com_RE_Entwicklungszustand?.map(
                                            (option, index) => ({ value: option, key: index })
                                        )}
                                        filterOption={(inputValue, option) =>
                                            option.value
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        onChange={handleSelectChange} // Add your change handler if needed
                                    >
                                        <TextArea
                                            placeholder="Entwicklungszustand"
                                            autoSize={true}
                                            className="textInput"
                                        />
                                    </AutoComplete>

                                </Form.Item>
                                <Form.Item label="Beitrags- & Abgabenzustand" name='Grundstueck__RE_Beitrags_AbgabenzustandV'>
                                    <AutoComplete
                                        className={"AutoCompleteTextArea"}
                                        options={enumerationValues.sub_com_RE_Beitrags_Abgabenzustand?.map(
                                            (option, index) => ({ value: option, key: index })
                                        )}
                                        filterOption={(inputValue, option) =>
                                            option.value
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        onChange={handleSelectChange} // Add your change handler if needed
                                    >
                                        <TextArea
                                            placeholder="Beitrags- & Abgabenzustand"
                                            autoSize={true}
                                            className="textInput"
                                        />
                                    </AutoComplete>

                                </Form.Item>
                                <Form.Item label="Bodenordnungsverfahren" name='Grundstueck__RE_BodenordnungsverfahrenV'>
                                    <AutoComplete
                                        className={"AutoCompleteTextArea"}
                                        options={enumerationValues.sub_com_RE_Bodenordnungsverfahren?.map(
                                            (option, index) => ({ value: option, key: index })
                                        )}
                                        filterOption={(inputValue, option) =>
                                            option.value
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        onChange={handleSelectChange} // Add your change handler if needed
                                    >
                                        <TextArea
                                            placeholder="Bodenordnungsverfahren"
                                            autoSize={true}
                                            className="textInput"
                                        />
                                    </AutoComplete>

                                </Form.Item>
                                <Form.Item label="Städtebauliche Maßnahmen / Satzungen" name='Grundstueck__RE_StaedtebaulichMassnahmenV'>
                                    <AutoComplete
                                        className={"AutoCompleteTextArea"}
                                        options={enumerationValues.sub_com_RE_StaedtebaulichMassnahmen?.map(
                                            (option, index) => ({ value: option, key: index })
                                        )}
                                        filterOption={(inputValue, option) =>
                                            option.value
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        onChange={handleSelectChange} // Add your change handler if needed
                                    >
                                        <TextArea
                                            placeholder="Städtebauliche Maßnahmen / Satzungen"
                                            autoSize={true}
                                            className="textInput"
                                        />
                                    </AutoComplete>

                                </Form.Item>
                                <Form.Item label="Nicht eingetragene Rechte und Lasten" name='Grundstueck__RE_neing_RechteundLastenV'>
                                    <AutoComplete
                                        className={"AutoCompleteTextArea"}
                                        options={enumerationValues.sub_com_RE_neing_RechteundLasten?.map(
                                            (option, index) => ({ value: option, key: index })
                                        )}
                                        filterOption={(inputValue, option) =>
                                            option.value
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        onChange={handleSelectChange} // Add your change handler if needed
                                    >
                                        <TextArea
                                            placeholder="Nicht eingetragene Rechte und Lasten"
                                            autoSize={true}
                                            className="textInput"
                                        />
                                    </AutoComplete>

                                </Form.Item>
                                <Form.Item label="Denkmalschutz" name='Grundstueck__RE_DenkmalschutzV'>
                                    <AutoComplete
                                        className={"AutoCompleteTextArea"}
                                        options={enumerationValues.sub_com_RE_Denkmalschutz?.map(
                                            (option, index) => ({ value: option, key: index })
                                        )}
                                        filterOption={(inputValue, option) =>
                                            option.value
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        onChange={handleSelectChange} // Add your change handler if needed
                                    >
                                        <TextArea
                                            placeholder="Denkmalschutz"
                                            autoSize={true}
                                            className="textInput"
                                        />
                                    </AutoComplete>

                                </Form.Item>
                                <Form.Item label="Baulasten" name='Grundstueck__RE_BaulastenV'>
                                    <AutoComplete
                                        className={"AutoCompleteTextArea"}
                                        options={enumerationValues.sub_com_RE_Baulasten?.map(
                                            (option, index) => ({ value: option, key: index })
                                        )}
                                        filterOption={(inputValue, option) =>
                                            option.value
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        onChange={handleSelectChange} // Add your change handler if needed
                                    >
                                        <TextArea
                                            placeholder="Baulasten"
                                            autoSize={true}
                                            className="textInput"
                                        />
                                    </AutoComplete>

                                </Form.Item>
                                <Form.Item label="Altlasten" name='Grundstueck__RE_AltlastenV'>
                                    <AutoComplete
                                        className={"AutoCompleteTextArea"}
                                        options={enumerationValues.sub_com_RE_Altlasten?.map(
                                            (option, index) => ({ value: option, key: index })
                                        )}
                                        filterOption={(inputValue, option) =>
                                            option.value
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        onChange={handleSelectChange} // Add your change handler if needed
                                    >
                                        <TextArea
                                            placeholder="Altlasten"
                                            autoSize={true}
                                            className="textInput"
                                        />
                                    </AutoComplete>

                                </Form.Item>
                            </div>
                        </div>
                        <div id="naturgefahren" className="scrollable-section border-t border-gray-300 pt-[20px] pb-[20px]">
                            <h3 className={`font-bold text-16px mb-[12px]  md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Naturgefahren</h3>
                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Naturgefahren" name='Grundstueck__RE_Naturgefahren'>
                                    <TextArea autoSize={true} className="textInput" ref={(element) => handleRef('Grundstueck__RE_Naturgefahren', element)} />
                                </Form.Item>
                            </div>

                        </div>
                        <div id="beurteilung-grundstueck" className="scrollable-section border-t border-gray-300 pt-[20px] pb-[20px]">
                            <h3 className={`font-bold text-16px mb-[12px]  md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Beurteilung Grundstück</h3>
                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Beurteilung Grundstück" name='Grundstueck__Beurteilung_Grundstueck'>
                                    <TextArea autoSize={true} className="textInput" ref={(element) => handleRef('Grundstueck__Beurteilung_Grundstueck', element)} />
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Grundstueck__Beurteilung_Grundstueck', 'Beurteilung Grundstück', 'Grundstück')} style={{ float: 'right' }} ><FileTextOutlined /></Button>
                            </div>

                        </div>

                    </Form>
                )}
            </div>
        </div>
    );
};

const Grundstueck = () => (
    <GutachtenShell menuLinks={MENU_LINKS}>
        <FormContainer />
    </GutachtenShell>
);

export default Grundstueck;
